module.exports = __webpack_public_path__ + "hyperion-v2-static/img/no_data_flood.0b99dd28.png";